<template>
  <div class="details">
    <NavBar></NavBar>
    <div class="title-block">
      <button class="return" onclick="history.back()">
        <v-icon>mdi-keyboard-return</v-icon>
      </button>
      <h1 class="text-h2 my-8 text-center">Détails du Thème</h1>
    </div>
    <div class="mx-16 pb-10 pl-16">
      <v-card class="data-table">
        <v-card-title
          class="title-details rounded-lg text-center d-flex justify-center"
        >
          Informations
        </v-card-title>
        <div class="d-flex flex-row align-start background-details flex-wrap">
          <v-list class="details-content d-flex flex-wrap pt-0 pb-8 w-100">
            <v-list-item class="w-100 pa-0" v-for="key in keyOrder1" :key="key">
              <div class="details-table-infos px-10 py-3">
                <div class="details-table-infos__cell">
                  <div :class="{ 'text-primary': key === 'TXT_Offer' }">
                    <strong>{{ keyTextMap[key] }} :</strong>
                  </div>
                  <div class="details-table-infos-content">
                    {{ theme[key] }}
                  </div>
                </div>
                <div
                  class="details-table-infos__edit"
                  @click="openUpdateDialog(key)"
                >
                  <v-icon icon="mdi-pencil" size="x-large"></v-icon>
                </div>
              </div>
            </v-list-item>

            <div class="w-100">
              <h2 class="px-10 mt-6 text-h6 font-weight-bold">
                Commentaires :
                <v-btn icon class="ml-2" @click="openAddCommentDialog">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </h2>

              <div class="comments-list px-10 mt-4 d-flex">
                <v-card
                  v-for="comment in reversedComments"
                  :key="comment.ID_FS_CommentsTheme"
                  class="comment-block pa-2 mb-4 rounded-lg"
                  color="secondary"
                >
                  <div class="comment-header d-flex justify-between">
                    <h3 class="comment-date mb-2 d-flex">
                      <span class="comment-date__user">
                        {{ comment.ID_NDAppUser }}
                      </span>
                      &nbsp;-&nbsp;
                      <span class="comment-date__date">
                        {{ formatDate(comment.DAT_Created) }}
                      </span>
                    </h3>
                    <div class="comment-actions">
                      <div
                        class="comment-edit"
                        @click="openCommentUpdateDialog(comment)"
                      >
                        <v-icon icon="mdi-pencil" size="x-large"></v-icon>
                      </div>
                      <div
                        class="comment-delete"
                        @click="openDeleteDialog(comment)"
                      >
                        <v-icon icon="mdi-delete" size="x-large"></v-icon>
                      </div>
                    </div>
                  </div>
                  <p class="comment-text">{{ comment.TXT_Comment }}</p>
                </v-card>
              </div>
            </div>

            <div class="px-10 py-3 mt-8 d-flex align-center">
              <h2 class="text-h6 font-weight-bold">Sous-Thèmes associés :</h2>
              <v-btn
                icon
                class="details-table-infos__edit ml-2"
                @click="openUpdateDialog('Subthemes')"
              >
                <v-icon icon="mdi-pencil" size="x-large"></v-icon>
              </v-btn>
            </div>
            <v-data-table
              :headers="SubThemesHeaders"
              :items="theme.Subthemes"
              class="w-100 related-data-table mx-10"
              color="table"
            >
              <template v-slot:[`item.TXT_SubTheme`]="{ item }">
                <router-link :to="`/subthemes/${item.ID_D_SubTheme}`">{{
                  item.TXT_SubTheme
                }}</router-link>
              </template>
            </v-data-table>

            <div
              class="d-flex w-100 mt-6 px-10 align-center justify-space-between"
            >
              <div class="details-dates d-flex">
                <div
                  class="w-100 pa-0 details-dates__element"
                  v-for="key in keyOrder2"
                  :key="key"
                >
                  <div class="element">
                    <div>
                      <strong>{{ keyTextMap[key] }} :</strong>
                    </div>
                    <div>
                      <!-- Utilisation de la méthode formatDate si la clé est une date -->
                      {{
                        key === "DAT_LastEdited" || key === "DAT_Created"
                          ? formatDate(theme[key])
                          : theme[key]
                      }}
                    </div>
                  </div>
                </div>
              </div>

              <v-btn color="primary" @click="openDeleteThemeDialog(theme)"
                >Supprimer le thème</v-btn
              >
            </div>
          </v-list>
        </div>
      </v-card>
    </div>

    <v-dialog
      v-if="fieldToUpdate === 'Subthemes'"
      v-model="dialog"
      transition="dialog-top-transition"
      persistent
      min-width="800"
    >
      <v-card class="rounded-lg pa-4" color="dialog">
        <v-card-title class="headline">{{ dialogTitle }}</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="search"
            clearable
            prepend-inner-icon="mdi-magnify"
            label="Rechercher..."
            single-line
            hide-details
            @keyup.enter="getSubThemes(true)"
            @click:prepend-inner="getSubThemes(true)"
            @click:clear="resetSearch"
            density="compact"
            bg-color="grey-darken-3"
            color="primary"
          ></v-text-field>
          <v-data-table-server
            :show-current-page="true"
            :headers="DialogSubThemesHeaders"
            v-model:page="currentPage"
            :items="PopupSubThemes"
            :items-length="totalSubThemes"
            items-per-page-text="Nombre d'élements par page."
            :loading="isLoading"
            no-data-text="Aucune donnée"
            @update:options="updateOptions"
            item-key="ID_D_SubTheme"
            density="compact"
          >
            <template v-slot:[`item.selected`]="{ item }">
              <v-checkbox
                class="d-flex justify-center ma-0 pa-0"
                v-model="item.selected"
                @change="updateSelectedItems(item)"
                density="compact"
              ></v-checkbox>
            </template>
          </v-data-table-server>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">Annuler</v-btn>
          <v-btn
            color="primary"
            text
            @click="confirmUpdate"
            :loading="isUpdating"
            :disabled="isUpdating"
          >
            Valider
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-if="fieldToUpdate !== 'Subthemes'"
      v-model="dialog"
      transition="dialog-top-transition"
      persistent
      max-width="800"
      min-width="400"
    >
      <v-card class="rounded-lg pa-4" color="dialog">
        <v-card-title class="headline">{{ dialogTitle }}</v-card-title>
        <v-card-text>
          <v-textarea
            v-if="
              fieldToUpdate !== 'Subthemes' &&
              fieldToUpdate !== 'TXT_Description' &&
              fieldToUpdate !== 'TXT_LearningObjectif'
            "
            rows="1"
            auto-grow
            variant="underlined"
            v-model="newFieldValue"
            :rules="[rules.required]"
            color="primary"
          ></v-textarea>

          <v-textarea
            v-else-if="
              fieldToUpdate === 'TXT_Description' ||
              fieldToUpdate === 'TXT_LearningObjectif'
            "
            rows="1"
            auto-grow
            variant="underlined"
            v-model="newFieldValue"
            color="primary"
          ></v-textarea>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">Annuler</v-btn>
          <v-btn color="primary" text @click="confirmUpdate">Confirmer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="addCommentDialog"
      transition="dialog-top-transition"
      persistent
      max-width="800"
      min-width="400"
    >
      <v-card class="rounded-lg pa-4" color="dialog">
        <v-card-title class="headline">Ajouter un commentaire</v-card-title>
        <v-card-text>
          <v-textarea
            rows="1"
            auto-grow
            variant="underlined"
            v-model="newComment"
            :rules="[rules.required]"
            color="primary"
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="addCommentDialog = false"
            >Annuler</v-btn
          >
          <v-btn color="primary" text @click="addComment">Ajouter</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="deleteDialog"
      transition="dialog-top-transition"
      persistent
      max-width="800"
      min-width="400"
    >
      <v-card class="rounded-lg pa-4" color="dialog">
        <v-card-title class="headline">Supprimer le commentaire</v-card-title>
        <v-card-text
          >Voulez-vous vraiment supprimer ce commentaire ?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="deleteDialog = false"
            >Annuler</v-btn
          >
          <v-btn color="primary" text @click="deleteComment">Confirmer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="deleteThemeDialog"
      transition="dialog-top-transition"
      persistent
      max-width="800"
      min-width="400"
    >
      <v-card class="rounded-lg pa-4" color="dialog">
        <v-card-title class="headline"
          >Êtes-vous sûr de vouloir supprimer ce thème ?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="deleteThemeDialog = false"
            >Annuler</v-btn
          >
          <v-btn color="primary" text @click="deleteTheme">Confirmer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="5000">
      <p v-html="snackbarMessage"></p>
    </v-snackbar>
    <FooterBar></FooterBar>

  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import authExpirationMixin from "@/mixins/isLogged.js";
import axios from "axios";
import {
  base_url,
  themes_urls,
  subthemes_urls,
  comments_urls,
  user_urls,
  header,
} from "@/API/config.js";
import FooterBar from "@/components/Footer.vue";

export default {
  mixins: [authExpirationMixin],
  name: "ThemeSlug",
  components: {
    FooterBar,
    NavBar,
  },
  data() {
    return {
      theme: {
        comments: [],
      },
      keyTextMap: {
        TXT_Theme: "Thème",
        TXT_Offer: "Offre",
        TXT_Description: "Description",
        TXT_LearningObjectif: "Objectif pédagogique",
        TXT_Ref: "Ref",
        DAT_Created: "Création",
        TXT_LastEditedBy: "Modifié par",
        DAT_LastEdited: "Dernière modification",
        Subthemes: "Sous-Thèmes associés",
      },
      keyOrder1: [
        "TXT_Theme",
        "TXT_Description",
        "TXT_LearningObjectif",
        "TXT_Ref",
        "TXT_Offer",
      ],
      keyOrder2: ["DAT_Created", "DAT_LastEdited", "TXT_LastEditedBy"],

      SubThemesHeaders: [
        { title: "Sous-thème", value: "TXT_SubTheme", key: "TXT_SubTheme" },
        {
          title: "Description",
          value: "TXT_Description",
          key: "TXT_Description",
        },
        {
          title: "Objectif pédagogique",
          value: "TXT_LearningObjectif",
          key: "TXT_LearningObjectif",
        },
      ],
      DialogSubThemesHeaders: [
        {
          title: "Sélectionner",
          value: "selected",
          key: "selected",
          sortable: false,
          width: "100px",
        },
        {
          title: "Sous-thème",
          value: "TXT_SubTheme",
          key: "TXT_SubTheme",
          sortable: false,
        },
        {
          title: "Description",
          value: "TXT_Description",
          key: "TXT_Description",
          sortable: false,
        },
        {
          title: "Objectif pédagogique",
          value: "TXT_LearningObjectif",
          key: "TXT_LearningObjectif",
          sortable: false,
        },
      ],
      totalSubThemes: 0,
      currentPage: 1,
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      PopupSubThemes: [],
      selectedItems: new Set(),

      dialog: false,
      dialogTitle: "",
      newFieldValue: "",
      fieldToUpdate: null,
      snackbar: false,
      snackbarMessage: "",
      snackbarColor: "success",

      currentCommentID: null,
      addCommentDialog: false,
      newComment: "",
      deleteDialog: false,
      commentToDelete: null,
      themeToDelete: null,
      deleteThemeDialog: false,

      Subthemes: [],
      search: "",
      isLoading: false,
      isUpdating: false,

      rules: {
        required: (value) => !!value || "Ce champ est requis.",
      },
    };
  },

  methods: {
    async initializeCacheBusting() {
      const cacheVersionKeys = Object.keys(localStorage).filter((key) =>
        key.startsWith("cacheVersion")
      );

      if (cacheVersionKeys.length > 0) {
        const latestCacheVersion = cacheVersionKeys.reduce((latest, key) => {
          const version = parseInt(localStorage.getItem(key));
          return version > latest ? version : latest;
        }, 0);

        return latestCacheVersion.toString();
      } else {
        const response = await axios.get(
          `${base_url}${subthemes_urls.get_all}`,
          header
        );
        const cacheVersion = response.data.results.cache_version;
        localStorage.setItem("cacheVersion", cacheVersion);
        return cacheVersion;
      }
    },

    updateCacheBusting(newCacheVersion) {
      localStorage.setItem(`cacheVersion_${newCacheVersion}`, newCacheVersion);
    },

    async refreshData() {
      const newCacheVersion = await this.initializeCacheBusting();
      const { itemsPerPage, page } = this.options;
      let url = `${base_url}${subthemes_urls.get_all}?page=${page}&page_size=${itemsPerPage}&cacheVersion=${newCacheVersion}`;
      if (this.search) {
        url += `&query=${encodeURIComponent(this.search)}`;
      }
      try {
        const response = await axios.get(url, header);
        this.totalSubThemes = response.data.count;
        this.PopupSubThemes = response.data.results.results.map((subtheme) => ({
          ...subtheme,
          selected: this.selectedItems.has(subtheme.ID_D_SubTheme),
        }));
      } catch (error) {
        console.error("Error refreshing subthemes data:", error);
      }
    },

    resetSearch() {
      this.search = "";
      this.getSubThemes(true);
    },

    updateSelectedItems(item) {
      if (item.selected) {
        this.selectedItems.add(item.ID_D_SubTheme);
      } else {
        this.selectedItems.delete(item.ID_D_SubTheme);
      }
    },

    updateOptions(newOptions) {
      this.options = newOptions;
    },

    openDeleteThemeDialog(theme) {
      this.themeToDelete = theme;
      this.deleteThemeDialog = true;
    },

    async fetchUserDetails() {
      const userId = localStorage.getItem("id");
      if (userId) {
        try {
          const response = await this.getUserDetails(userId);
          this.userDetails = response.data;
        } catch (error) {
          console.error(
            "Erreur lors de la récupération des détails de l'utilisateur:",
            error
          );
          this.snackbarMessage =
            "Erreur lors de la vérification des droits utilisateur.";
          this.snackbarColor = "error";
          this.snackbar = true;
        }
      } else {
        this.snackbarMessage =
          "Impossible de vérifier les droits utilisateur. Veuillez vous reconnecter.";
        this.snackbarColor = "error";
        this.snackbar = true;
      }
    },

    async deleteTheme() {
      const themeId = this.$route.params.id;
      const url = `${base_url}${themes_urls.archive(themeId)}`;

      await this.fetchUserDetails();

      if (!this.userDetails?.is_superuser) {
        this.snackbarMessage =
          "Vous n'avez pas les droits nécessaires pour supprimer ce thème.";
        this.snackbarColor = "error";
        this.snackbar = true;
        return;
      }

      if (this.themeToDelete) {
        const payload = {
          is_admin: true,
        };

        try {
          await axios.post(url, payload, header);
          this.snackbarMessage = `Le Thème a été supprimé.`;
          this.snackbar = true;
          const newCacheVersion = new Date().getTime().toString();
          localStorage.setItem("cacheVersion", newCacheVersion);
          this.$router.push("/themes");
        } catch (error) {
          console.error("Erreur lors de la suppression du thème:", error);

          this.snackbarMessage = `Erreur lors de la suppression du <strong>Thème</strong>`;
          this.snackbarColor = "error";
          this.snackbar = true;
        }
        this.deleteThemeDialog = false;
      }
    },

    async getSubThemes(resetPage = false) {
      if (resetPage) {
        this.currentPage = 1;
        this.options.page = 1;
      }

      this.isLoading = true;
      const cacheVersion = await this.initializeCacheBusting();
      const { itemsPerPage, page } = this.options;
      let url = `${base_url}${subthemes_urls.get_all}?page=${page}&page_size=${itemsPerPage}&cacheVersion=${cacheVersion}`;
      if (this.search) {
        url += `&query=${encodeURIComponent(this.search)}`;
      }
      try {
        const response = await axios.get(url, header);
        this.totalSubThemes = response.data.count;
        this.PopupSubThemes = response.data.results.results.map((subtheme) => ({
          ...subtheme,
          selected: this.selectedItems.has(subtheme.ID_D_SubTheme),
        }));
        this.currentPage = page;

        if (response.data.results.cache_version !== cacheVersion) {
          this.updateCacheBusting(response.data.results.cache_version);
          await this.refreshData();
        }
      } catch (error) {
        console.error("Error fetching subthemes:", error);
      } finally {
        this.isLoading = false;
      }
    },

    getUserDetails(id) {
      const url = `${base_url}${user_urls.get_details(id)}`;
      return axios.get(url, header);
    },

    getThemeDetails() {
      const themeId = this.$route.params.id;
      const url = `${base_url}${themes_urls.get_details(themeId)}`;
      const commentsUrl = `${base_url}${comments_urls.theme_all}`; // Fetch all comments

      axios
        .get(url, header)
        .then((response) => {
          this.theme = {
            ...response.data, // As your API returns an array, we need the first object from the array
          };
          // Get user details
          if (this.theme.TXT_LastEditedBy) {
            return this.getUserDetails(this.theme.TXT_LastEditedBy);
          } else {
            return Promise.resolve(null);
          }
        })
        .then((userResponse) => {
          // Replace the user ID with username
          if (userResponse) {
            this.theme.TXT_LastEditedBy = userResponse.data.username;
          }
          return axios.get(commentsUrl, header);
          // Fetch comments
        })
        .then((commentsResponse) => {
          // Filter comments based on themeId
          this.theme.comments = commentsResponse.data.filter(
            (comment) => comment.ID_D_Theme === parseInt(themeId)
          );
          // Get user details for each unique user ID in the comments
          const uniqueUserIds = [
            ...new Set(
              this.theme.comments.map((comment) => comment.ID_NDAppUser)
            ),
          ];
          return Promise.all(
            uniqueUserIds.map((userId) => this.getUserDetails(userId))
          );
        })
        .then((userResponses) => {
          // Replace the user ID with username in comments
          userResponses.forEach((userResponse) => {
            const username = userResponse.data.username;
            this.theme.comments.forEach((comment) => {
              if (comment.ID_NDAppUser === userResponse.data.id) {
                comment.ID_NDAppUser = username;
              }
            });
          });
        })
        .catch((error) => {
          console.error("Error fetching theme details:", error);
        });
    },

    openUpdateDialog(key) {
      this.dialogTitle = `Modifier ${this.keyTextMap[key]}`;
      this.fieldToUpdate = key;
      if (key === "Subthemes") {
        this.getSubThemes();
        this.selectedItems = new Set(
          this.theme.Subthemes.map((subtheme) => subtheme.ID_D_SubTheme)
        );
      } else {
        this.newFieldValue = this.theme[key];
      }
      this.dialog = true;
    },

    async confirmUpdate() {
      this.isUpdating = true;
      try {
        if (this.fieldToUpdate === "Subthemes") {
          this.newFieldValue = Array.from(this.selectedItems);
          await this.updateTheme(this.fieldToUpdate, this.newFieldValue);
        } else if (
          this.fieldToUpdate === "TXT_Description" ||
          this.fieldToUpdate === "TXT_LearningObjectif" ||
          (this.newFieldValue !== undefined &&
            this.newFieldValue !== null &&
            this.newFieldValue !== "")
        ) {
          if (this.fieldToUpdate === "TXT_Comment") {
            await this.updateComment(this.currentCommentID, this.newFieldValue);
          } else {
            await this.updateTheme(this.fieldToUpdate, this.newFieldValue);
          }
        }
      } catch (error) {
        console.error("Error during update:", error);
      } finally {
        this.isUpdating = false;
        this.dialog = false;
      }
    },

    updateComment(commentId, newComment) {
      const url = `${base_url}${comments_urls.theme_details(commentId)}`;

      axios
        .put(url, { TXT_Comment: newComment }, header)
        .then(() => {
          const commentIndex = this.theme.comments.findIndex(
            (comment) => comment.ID_FS_CommentsTheme === commentId
          );
          this.theme.comments[commentIndex].TXT_Comment = newComment;

          const newCacheVersion = new Date().getTime().toString();
          localStorage.setItem("cacheVersion", newCacheVersion);

          this.snackbarMessage = `Le commentaire a été mis à jour.`;
          this.snackbar = true;
        })
        .catch((error) => {
          console.error("Error updating comment:", error);

          this.snackbarMessage = `Une erreur s'est produite lors de la mise à jour du <strong>Commentaire</strong>`;
          this.snackbarColor = "error";
          this.snackbar = true;
        });
    },

    async updateSubtheme(subthemeId, themeId) {
      const url = `${base_url}${subthemes_urls.get_details(subthemeId)}`;
      try {
        const response = await axios.get(url, header);
        const subthemeData = response.data;

        subthemeData.Themes = themeId;

        const userDetails = await this.getUserDetails(
          this.$store.state.auth.id
        );
        subthemeData.TXT_LastEditedBy = userDetails.data.id;

        subthemeData.DAT_LastEdited = new Date().toISOString();

        const updateResponse = await axios.put(url, subthemeData, header);

        if (updateResponse.data && updateResponse.data.cache_version) {
          this.updateCacheBusting(updateResponse.data.cache_version);
        } else {
          const currentVersion = await this.initializeCacheBusting();
          this.updateCacheBusting(String(parseInt(currentVersion) + 1));
        }
      } catch (error) {
        console.error(
          `Erreur lors de la mise à jour du sous-thème ${subthemeId}:`,
          error
        );
        throw error;
      }
    },

    async updateTheme(field, newValue) {
      const themeId = this.$route.params.id;
      const url = `${base_url}${themes_urls.update(themeId)}`;

      const updatedData = {
        TXT_Theme: this.theme.TXT_Theme,
        TXT_Description: this.theme.TXT_Description,
        TXT_LearningObjectif: this.theme.TXT_LearningObjectif,
        TXT_Ref: this.theme.TXT_Ref,
        DAT_Created: this.theme.DAT_Created,
        [field]: newValue,
        DAT_LastEdited: new Date().toISOString(),
        TXT_CreatedBy: this.theme.TXT_CreatedBy,
        TXT_LastEditedBy: this.$store.state.auth.id,
      };

      if (field === "Subthemes") {
        try {
          // Récupérer la liste actuelle des sous-thèmes
          const currentSubthemes = this.theme.Subthemes.map(
            (subtheme) => subtheme.ID_D_SubTheme
          );

          // Identifier les sous-thèmes à ajouter et à retirer
          const subthemesToAdd = newValue.filter(
            (id) => !currentSubthemes.includes(id)
          );
          const subthemesToRemove = currentSubthemes.filter(
            (id) => !newValue.includes(id)
          );

          // Mettre à jour les sous-thèmes
          for (const subthemeId of subthemesToAdd) {
            await this.updateSubtheme(subthemeId, themeId);
          }
          for (const subthemeId of subthemesToRemove) {
            await this.updateSubtheme(subthemeId, null);
          }

          // Mettre à jour le thème local
          this.theme.Subthemes = newValue.map((id) => ({ ID_D_SubTheme: id }));
        } catch (error) {
          console.error(
            "Erreur lors de la mise à jour des sous-thèmes:",
            error
          );
          this.snackbarMessage = `Une erreur s'est produite lors de la mise à jour des sous-thèmes`;
          this.snackbarColor = "error";
          this.snackbar = true;
          return;
        }
      }

      try {
        const response = await axios.put(url, updatedData, header);
        this.theme = response.data;

        const newCacheVersion = new Date().getTime().toString();
        localStorage.setItem("cacheVersion", newCacheVersion);

        this.getThemeDetails();

        this.snackbarMessage = `Le champ <strong>${this.keyTextMap[field]}</strong> a été mis à jour`;
        this.snackbarColor = "success";
        this.snackbar = true;
      } catch (error) {
        console.error(error);
        this.snackbarMessage = `Une erreur s'est produite lors de la mise à jour du champ <strong>${this.keyTextMap[field]}</strong>`;
        this.snackbarColor = "error";
        this.snackbar = true;
      }
    },

    formatDate(date) {
      const dateObject = new Date(date);
      const options = { day: "2-digit", month: "2-digit", year: "numeric" };
      const formattedDate = dateObject.toLocaleDateString("fr-FR", options);
      return formattedDate;
    },

    openCommentUpdateDialog(comment) {
      this.dialogTitle = `Modifier le commentaire de ${this.formatDate(
        comment.DAT_Created
      )}`;
      this.fieldToUpdate = "TXT_Comment";
      this.newFieldValue = comment.TXT_Comment;
      this.dialog = true;
      this.currentCommentID = comment.ID_FS_CommentsTheme; // Stocker l'ID du commentaire actuel
    },

    openAddCommentDialog() {
      this.newComment = ""; // Reset the new comment field
      this.addCommentDialog = true;
    },

    addComment() {
      const url = `${base_url}${comments_urls.theme_all}`;

      const commentData = {
        ID_NDAppUser: this.$store.state.auth.id,
        DAT_Created: new Date().toISOString(),
        TXT_Comment: this.newComment,
        ID_D_Theme: this.$route.params.id,
      };

      axios
        .post(url, commentData, header)
        .then(() => {
          this.getThemeDetails(); // Fetch subtheme details again to update the comments list

          const newCacheVersion = new Date().getTime().toString();
          localStorage.setItem("cacheVersion", newCacheVersion);

          this.snackbarMessage = `Votre commentaire a été ajouté avec succès.`;
          this.snackbar = true;

          this.addCommentDialog = false;
        })
        .catch((error) => {
          console.error("Error adding comment:", error);

          this.snackbarMessage = `Une erreur s'est produite lors de l'ajout du commentaire`;
          this.snackbarColor = "error";
          this.snackbar = true;
        });
    },

    openDeleteDialog(comment) {
      this.commentToDelete = comment;
      this.deleteDialog = true;
    },

    deleteComment() {
      if (this.commentToDelete) {
        const url = `${base_url}${comments_urls.delete_theme(
          this.commentToDelete.ID_FS_CommentsTheme
        )}`;

        axios
          .delete(url, header)
          .then(() => {
            this.getThemeDetails();

            const newCacheVersion = new Date().getTime().toString();
            localStorage.setItem("cacheVersion", newCacheVersion);

            this.snackbarMessage = `Votre commentaire a été supprimé.`;
            this.snackbar = true;

            this.deleteDialog = false;
          })
          .catch((error) => {
            console.error("Error deleting comment:", error);

            this.snackbarMessage = `Erreur lors de la suppression du commentaire`;
            this.snackbarColor = "error";
            this.snackbar = true;
          });
      }
    },
  },
  watch: {
    dialog(newVal) {
      if (newVal && this.fieldToUpdate === "Subthemes") {
        this.getSubThemes();
      }
    },
    PopupSubThemes: {
      handler(newItems) {
        newItems.forEach((item) => {
          if (item.selected) {
            this.selectedItems.add(item.ID_D_SubTheme);
          } else {
            this.selectedItems.delete(item.ID_D_SubTheme);
          }
        });
      },
      deep: true,
    },
    options: {
      handler() {
        if (this.fieldToUpdate === "Subthemes") {
          this.getSubThemes();
        }
      },
      deep: true,
    },
  },

  computed: {
    reversedComments() {
      return [...(this.theme.comments || [])].reverse();
    },
    formattedSubThemes() {
      if (!this.search) {
        return this.Subthemes.map((subTheme) => ({
          title:
            subTheme.TXT_SubTheme.length > 75
              ? subTheme.TXT_SubTheme.substring(0, 75) + "..."
              : subTheme.TXT_SubTheme,
          value: subTheme.ID_D_SubTheme,
        }));
      }
      const searchTerms = this.search
        .toLowerCase()
        .split(" ")
        .filter((word) => word.length > 0);
      return this.Subthemes.filter((subTheme) => {
        const subThemeLowerCase = subTheme.TXT_SubTheme.toLowerCase();
        return searchTerms.every((term) => subThemeLowerCase.includes(term));
      }).map((subTheme) => ({
        title:
          subTheme.TXT_SubTheme.length > 75
            ? subTheme.TXT_SubTheme.substring(0, 75) + "..."
            : subTheme.TXT_SubTheme,
        value: subTheme.ID_D_SubTheme,
      }));
    },
  },

  created() {
    this.getThemeDetails();
    this.getSubThemes();
  },

  mounted() {
    document.title = "Thème - Détails";
  },
};
</script>

<style lang="scss">
.details .data-table .v-table .v-data-table__td {
  width: 33%;
}
</style>
